<h3 class="text-[#292F32]" mat-dialog-title>{{ data.title }}</h3>
<mat-dialog-content class="mr-075-rem whitespace-pre-line">{{ data.message }}</mat-dialog-content>
<div class="flex flex-col justify-center px-150-rem pb-050-rem">
  @if(data.showTextarea){
  <form [formGroup]="rejectionRemarksForm" class="w-full">
    <mat-form-field class="w-full rejection-remarks-form" appearance="outline">
      <textarea
        matInput
        [placeholder]="data.placeholder || 'Rejection remarks'"
        formControlName="remarks"
        rows="4"
        maxlength="500"
        class="no-resize textarea"
        name="rejectRemarks"></textarea>
      <mat-hint
        class="text-label-sm-weight-regular text-container-fg-muted flex gap-1 pt-1.5"
        [ngClass]="{
    'text-feedback-fg-error': submitAttempted() && rejectionRemarksForm.invalid
  }">
        <i
          class="icon_marina_ui_CrossContainedOutlined"
          [ngClass]="{
    'hidden': !(submitAttempted() && rejectionRemarksForm.invalid)
  }"></i>
        <p> {{ data.helperText || 'Add the reason why you reject the activation (max.500 characters).' }}</p>
      </mat-hint>
    </mat-form-field>
  </form>
  }
</div>
<mat-dialog-actions align="end">
  <button tabindex="-1" mat-button (click)="onCancel()">{{data.leftButton}}</button>
  <button
    mat-flat-button
    [ngClass]="{'bg-action-bg-error!': data.isDangerous}"
    color="primary"
    (click)="onConfirm()">
    {{data.rightButton}}
  </button>
</mat-dialog-actions>
